import Button from "public/shared/ui/inputs/classicButton.js";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./style.css";
const container = document.createElement("div");
container.id = "dialog-container";
container.classList.add("prompt-container");
container.classList.add("dialog-container");
document.body.appendChild(container);
/**
 *
 * @param props
 * @returns
 */
export default function Dialog(props) {
    const { children, cancelButtonText, confirmButtonText, onSubmit, onReject, withSubmit = true, withReject = true, maxWidth, } = props;
    if (!container) {
        throw new Error("Prompt container not found. Ensure it exists in your HTML.");
    }
    useEffect(() => {
        container.classList.add("visible");
        return () => {
            container.classList.remove("visible");
        };
    }, []);
    return ReactDOM.createPortal(React.createElement("div", { className: "prompt-box disable-popup-close", style: { maxWidth: maxWidth } },
        children,
        React.createElement("div", { className: "alert-buttons-menu-container" },
            withReject && (React.createElement(Button, { value: "reject", text: cancelButtonText || "Anuluj", version: "alternative", onClick: onReject })),
            withSubmit && (React.createElement(Button, { value: "process", text: confirmButtonText || "Wykonaj", version: "classic", onClick: onSubmit })))), container);
}
